module.exports = __webpack_public_path__ + "assets/img/ai-icon.svg";